import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { EstadoVazioComponentModule } from '../../components/estado-vazio/estado-vazio.module';
import { SelectComponentModule } from '../../components/select/select.module';
import { BrMaskerModule } from 'br-mask';
import {ModalSelecionarFiltroComponent} from './modal-selecionar-filtro.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    EstadoVazioComponentModule,
    SelectComponentModule,
    BrMaskerModule,
  ],
  exports: [
    ModalSelecionarFiltroComponent
  ],
  declarations: [ModalSelecionarFiltroComponent],
  entryComponents: [ModalSelecionarFiltroComponent],
})
export class ModalSelecionarFiltroComponentModule {
}
